import React, {setState, useRef, useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux'
import styles from "./Invoices.module.css";
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import PropTypes from 'prop-types';
import { makeStyles, useTheme, alpha } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container'
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useSnackbar } from 'react-simple-snackbar'
import {DataGrid, GridToolbar, GridCellEditStopReasons, GridComparatorFn, DEFAULT_GRID_AUTOSIZE_OPTIONS} from "@mui/x-data-grid";
import axios from 'axios';
import ProgressButton from 'react-progress-button'
import { deleteInvoice } from '../../actions/invoiceActions';
import { getAccountsByUser } from '../../actions/accountActions';
import { useLocation } from 'react-router-dom';
import useAuthUser from '../../hooks/useAuthUser'
import { formatDollarsToCents, formatCentsToDollars, displayAsDollars, displayFromDollars } from '../../utils/money'
import { fetchInvoiceList, fetchInvoicePrintRows, fetchInvoiceStatementRows } from '../../api';

import NoData from '../svgIcons/NoData';
import Spinner from '../Spinner/Spinner'


import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { getVisibleRows } from '@mui/x-data-grid/internals';

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),

  },
}));

const useStyles2 = makeStyles(theme => ({
  table: {
    minWidth: 500,
    
  },

  tablecell: {
    fontSize: '16px'
}
}));

const tableStyle = { width: 160, fontSize: 14, cursor: 'pointer', borderBottom: 'none',  padding: '8px', textAlign: 'center' }
const headerStyle = { borderBottom: 'none', textAlign: 'center'}
const SEND_FLOW = [
  { eventType: 'pc_pdf', label: 'Sent to PC' },
  { eventType: 'customer_pdf', label: 'Sent to Customer' },
  { eventType: 'proof_of_delivery', label: 'Sent Proof of Delivery' },
]

const getStatementDueDateTime = (row) => {
  if (!row?.dueDate) return Number.POSITIVE_INFINITY;
  const dueDateTime = new Date(row.dueDate).getTime();
  return Number.isNaN(dueDateTime) ? Number.POSITIVE_INFINITY : dueDateTime;
};

const INVOICE_GRID_STATE_KEY = 'pmWholesaleInvoiceGridState:v2';
const DEFAULT_INVOICE_GRID_STATE = {
  filterModel: { items: [] },
  sortModel: [{ field: 'receivedByDate', sort: 'desc' }],
  paginationModel: { page: 0, pageSize: 50 },
};

const readInvoiceGridState = () => {
  try {
    const stored = window.sessionStorage.getItem(INVOICE_GRID_STATE_KEY);
    if (!stored) return DEFAULT_INVOICE_GRID_STATE;
    const parsed = JSON.parse(stored);
    return {
      filterModel: parsed?.filterModel || DEFAULT_INVOICE_GRID_STATE.filterModel,
      sortModel: Array.isArray(parsed?.sortModel) ? parsed.sortModel : DEFAULT_INVOICE_GRID_STATE.sortModel,
      paginationModel: parsed?.paginationModel || DEFAULT_INVOICE_GRID_STATE.paginationModel,
    };
  } catch {
    return DEFAULT_INVOICE_GRID_STATE;
  }
};

const normalizeSingleFilterValue = (value) => {
  if (Array.isArray(value)) return value[0] || '';
  return value || '';
};


const Invoices = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const isMobile = useMediaQuery('(max-width:600px)')
  const { profiles } = useSelector(state => state.profiles || {});
  const { accounts = [] } = useSelector(state => state.accounts || {});
  const authData = useAuthUser()
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [clientOptions, setClientOptions] = useState([]);
  const [todayBoundaryInvoiceId, setTodayBoundaryInvoiceId] = useState('');
  const [listLoading, setListLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const isLoading = listLoading;
        // eslint-disable-next-line 
  const [openSnackbar, closeSnackbar] = useSnackbar()
  const [downloadStatus, setDownloadStatus] = useState('disabled')
  const [downloadTdStatus, setDownloadTdStatus] = useState('')
  const [downloadStatementStatus, setDownloadStatementStatus] = useState('disabled')
  const [sendStatementStatus, setSendStatementStatus] = useState('disabled')
  const [gridState, setGridState] = React.useState(readInvoiceGridState);
  const [mobileDetailInvoice, setMobileDetailInvoice] = useState(null);
  const [mobileDetailOpen, setMobileDetailOpen] = useState(false);
  const profileDetail = React.useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('profileDetail') || '{}');
    } catch {
      return {};
    }
  }, []);
  const warehouseEmailList = profiles?.emailWarehouseList || profileDetail?.emailWarehouseList || '';
  const statuses = ['Unpaid', 'Paid', 'Partial']
  const invoiceClientLabel = React.useCallback((row = {}) => row?.client?.store || row?.client?.name || '', []);
  const clientArray = React.useMemo(() => {
    if (clientOptions.length) return clientOptions;
    return [...new Set((rows || []).map(invoiceClientLabel).filter(Boolean))].sort();
  }, [clientOptions, invoiceClientLabel, rows]);




  // const rows = []


    // useEffect(() => {
    //     dispatch(getInvoices());
    // }, [dispatch]);

    useEffect(() => {
        const searchId = authData?.result?._id || authData?.result?.googleId
        if (searchId) {
          dispatch(getAccountsByUser({ search: searchId }));
        }
      // eslint-disable-next-line
    },[location, authData])

    const updateGridState = React.useCallback((updater) => {
      setGridState((prev) => {
        const next = typeof updater === 'function' ? updater(prev) : { ...prev, ...updater };
        try {
          window.sessionStorage.setItem(INVOICE_GRID_STATE_KEY, JSON.stringify(next));
        } catch {
          // Ignore storage failures so the grid remains usable.
        }
        return next;
      });
    }, []);

    useEffect(() => {
      let cancelled = false;
      setListLoading(true);
      fetchInvoiceList({
        page: gridState.paginationModel?.page || 0,
        pageSize: gridState.paginationModel?.pageSize || 20,
        filters: gridState.filterModel?.items || [],
        sortModel: gridState.sortModel || [],
      })
        .then(({ data }) => {
          if (cancelled) return;
          setRows(data?.data || []);
          setRowCount(Number(data?.total || 0));
          setClientOptions(data?.clientOptions || []);
          setTodayBoundaryInvoiceId(data?.todayBoundaryInvoiceId || '');
        })
        .catch((error) => {
          console.log(error?.response || error);
          if (!cancelled) {
            setRows([]);
            setRowCount(0);
          }
        })
        .finally(() => {
          if (!cancelled) setListLoading(false);
        });
      return () => {
        cancelled = true;
      };
    }, [gridState.filterModel, gridState.paginationModel, gridState.sortModel, refreshKey]);

    useEffect(() => {
      const filterItems = gridState.filterModel?.items || [];
      const receivedDateFilter = filterItems.find(
        (item) => item.field === 'receivedByDate' && item.value !== undefined && item.value !== ''
      );
      const clientFilter = filterItems.find(
        (item) => item.field === 'client' && item.value !== undefined && item.value !== ''
      );

      setDownloadStatus(receivedDateFilter ? '' : 'disabled');
      setSelectedClientFilter(normalizeSingleFilterValue(clientFilter?.value));
    }, [gridState.filterModel])

   const toCommas = (value) => {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rows.length);
  const [deleteTargetId, setDeleteTargetId] = useState(null);

  // const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

  // const handleDateChange = (value) => {
  //   if (value !== null) {
  //     let val = moment(value).format('MM/DD/yyyy');
  //     setSelectedDate(val);
  //     const filteredRows = invoices.filter((row) => {
  //       if (moment(row.receivedByDate).format('MM/DD/yyyy').includes(val)) {
  //         return true;
  //       }
  //       return false;
  //     });
  //     if (filteredRows.length > 0) {
  //       setDownloadStatus('')
  //     }
  //     setRows(filteredRows);
  //   } else {
  //     //setDownloadStatus('disabled')
  //     setRows(invoices);
  //   }
  // }


  // Print Invoices
  const printInvoices = async () => {
    if (downloadStatus === 'disabled') return;
    try {
      setDownloadStatus('loading')
      const { data } = await fetchInvoicePrintRows({
        filters: gridState.filterModel?.items || [],
        sortModel: gridState.sortModel || [],
      });
      const printRows = data?.data || [];
      if (printRows.length === 0) {
        setDownloadStatus('error')
        return
      }
      let pdfList = printRows.map(row => {
        //Get the total amount paid
        let totalAmountReceived = 0
        for(var i = 0; i < row?.paymentRecords?.length; i++) {
            totalAmountReceived += Number(row?.paymentRecords[i]?.amountPaid)
        }
        return { name: row.client.name,
          store: row.client.store,
          address: row.client.address,
          phone: row.client.cellPhone,
          email: row.client.email,
          dueDate: row.dueDate,
          receivedByDate: row.receivedByDate,
          date: row.createdAt,
          id: row.rowNumber,
          notes: row.notes,
          subTotal: toCommas(row.subTotal),
          total: toCommas(row.total),
          type: row.type,
          salesTax: row.salesTax,
          deliveryFee: row.deliveryFee,
          items: row.items,
          status: row.status,
          totalAmountReceived: toCommas(totalAmountReceived),
          balanceDue: toCommas(row.total - totalAmountReceived),
          paymentRecords: row.paymentRecords,
      }
      })
      axios.post(`${process.env.REACT_APP_API}/pdfs/create-pdf-landscape`, 
      { pdfDate : '', pdfList }
      , {responseType: 'blob'})
        .then((res) => {
          const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(pdfBlob);
          //Open the URL on new Window
           const pdfWindow = window.open();
           pdfWindow.location.href = fileURL;  
          // saveAs(pdfBlob, 'invoice.pdf')
        }).then(() =>  setDownloadStatus('success'))
    } catch (error) {
      console.log(error?.response || error)
      setDownloadStatus('error')
    }
   }

   // Print Invoices
  const printTdInvoices = async () => {
    try {
      setDownloadTdStatus('loading')
      const { data } = await fetchInvoicePrintRows({
        today: true,
        sortModel: gridState.sortModel || [],
      });
      const printRows = data?.data || [];
      if (printRows.length === 0) {
        setDownloadTdStatus('error')
        return
      }
      let pdfList = printRows.map(row => {
        //Get the total amount paid
        let totalAmountReceived = 0
        for(var i = 0; i < row?.paymentRecords?.length; i++) {
            totalAmountReceived += Number(row?.paymentRecords[i]?.amountPaid)
        }
        return { name: row.client.name,
          store: row.client.store,
          address: row.client.address,
          phone: row.client.cellPhone,
          email: row.client.email,
          dueDate: row.dueDate,
          receivedByDate: row.receivedByDate,
          date: row.createdAt,
          id: row.rowNumber,
          notes: row.notes,
          subTotal: toCommas(row.subTotal),
          total: toCommas(row.total),
          type: row.type,
          salesTax: row.salesTax,
          deliveryFee: row.deliveryFee,
          items: row.items,
          status: row.status,
          totalAmountReceived: toCommas(totalAmountReceived),
          balanceDue: toCommas(row.total - totalAmountReceived),
          paymentRecords: row.paymentRecords,
      }
      })
      axios.post(`${process.env.REACT_APP_API}/pdfs/create-pdf-landscape`, 
      { pdfDate : '', pdfList }
      , {responseType: 'blob'})
        .then((res) => {
          const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(pdfBlob);
          //Open the URL on new Window
           const pdfWindow = window.open();
           pdfWindow.location.href = fileURL;  
          // saveAs(pdfBlob, 'invoice.pdf')
        }).then(() =>  setDownloadTdStatus('success'))
    } catch (error) {
      console.log(error?.response || error)
      setDownloadTdStatus('error')
    }
  }

  const [selectedClientFilter, setSelectedClientFilter] = useState('');

  const resolveStatementClient = React.useCallback((statementRows = []) => {
    if (!statementRows.length) return null;
    const row = statementRows[0] || {};
    const client = row?.client || {};
    const accountId = row?.billTo?.accountId || client?.accountId;
    const accountMatch =
      accounts.find((acc) => acc?._id === accountId) ||
      accounts.find((acc) => acc?.name === selectedClientFilter);
    const emailFromAccount = accountMatch?.email || '';
    const emailFromClient = client.email || client?.emailAddress || '';
    return { ...client, email: emailFromAccount || emailFromClient };
  }, [accounts, selectedClientFilter]);

  const fetchStatementContext = React.useCallback(async () => {
    const { data } = await fetchInvoiceStatementRows({ client: selectedClientFilter });
    const statementRows = (data?.data || [])
      .sort((a, b) => getStatementDueDateTime(a) - getStatementDueDateTime(b));
    return {
      statementRows,
      statementClient: resolveStatementClient(statementRows),
    };
  }, [resolveStatementClient, selectedClientFilter]);

  useEffect(() => {
    const enabled = selectedClientFilter ? '' : 'disabled';
    setDownloadStatementStatus(enabled);
    setSendStatementStatus(enabled);
  }, [selectedClientFilter]);

  const downloadStatement = async () => {
    if (!selectedClientFilter) {
      setDownloadStatementStatus('error');
      return;
    }
    setDownloadStatementStatus('loading');
    const pdfWindow = window.open('', '_blank');
    if (pdfWindow) {
      try {
        pdfWindow.document.write('<!doctype html><title>Preparing statement</title><p>Preparing statement...</p>');
        pdfWindow.document.close();
      } catch {
        // Keep the request moving even if the browser blocks writing to the placeholder tab.
      }
    }
    let statementRows = [];
    let client = null;
    try {
      const context = await fetchStatementContext();
      statementRows = context.statementRows;
      client = context.statementClient;
    } catch (error) {
      console.log(error?.response || error);
    }
    if (!statementRows.length || !client) {
      if (pdfWindow && !pdfWindow.closed) pdfWindow.close();
      setDownloadStatementStatus('error');
      return;
    }
    const pdfList = statementRows.map((row) => {
      let totalAmountReceived = 0;
      for (var i = 0; i < row?.paymentRecords?.length; i++) {
        totalAmountReceived += Number(row?.paymentRecords[i]?.amountPaid);
      }
      return {
        name: row.client.name,
        store: row.client.store,
        address: row.client.address,
        phone: row.client.cellPhone,
        email: row.client.email,
        dueDate: row.dueDate,
        receivedByDate: row.receivedByDate,
        date: row.createdAt,
        rowNumber: row.rowNumber,
        invoiceNumber: row.invoiceNumber,
        clientPONumber: row.clientPONumber,
        notes: row.notes,
        subTotal: Number(row.subTotal || 0),
        total: Number(row.total || 0),
        type: row.type,
        salesTax: Number(row.salesTax || 0),
        deliveryFee: Number(row.deliveryFee || 0),
        items: row.items,
        status: row.status,
        totalAmountReceived,
        balanceDue: Number(row.total || 0) - totalAmountReceived,
        paymentRecords: row.paymentRecords,
      };
    });

    axios
      .post(
        `${process.env.REACT_APP_API}/pdfs/create-statement`,
        { client, invoices: pdfList },
        { responseType: 'blob' }
      )
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(pdfBlob);
        if (pdfWindow) {
          pdfWindow.location.href = fileURL;
        } else {
          const downloadLink = document.createElement('a');
          downloadLink.href = fileURL;
          downloadLink.download = `${selectedClientFilter}-statement.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
      })
      .then(() => setDownloadStatementStatus('success'))
      .catch(() => {
        if (pdfWindow && !pdfWindow.closed) {
          pdfWindow.close();
        }
        setDownloadStatementStatus('error');
      });
  };

  const sendStatement = async () => {
    if (!selectedClientFilter) {
      setSendStatementStatus('error');
      return;
    }
    let statementRows = [];
    let client = null;
    try {
      const context = await fetchStatementContext();
      statementRows = context.statementRows;
      client = context.statementClient;
    } catch (error) {
      console.log(error?.response || error);
    }
    const recipientEmail = client?.email || '';
    if (!statementRows.length || !recipientEmail) {
      setSendStatementStatus('error');
      return;
    }
    setSendStatementStatus('loading');
    const payload = {
      client,
      invoices: statementRows.map((row) => {
        let totalAmountReceived = 0;
        for (var i = 0; i < row?.paymentRecords?.length; i++) {
          totalAmountReceived += Number(row?.paymentRecords[i]?.amountPaid);
        }
        return {
          name: row.client.name,
          store: row.client.store,
          address: row.client.address,
          phone: row.client.cellPhone,
          email: row.client.email,
          dueDate: row.dueDate,
          receivedByDate: row.receivedByDate,
          date: row.createdAt,
          rowNumber: row.rowNumber,
          invoiceNumber: row.invoiceNumber,
          clientPONumber: row.clientPONumber,
          notes: row.notes,
          subTotal: Number(row.subTotal || 0),
          total: Number(row.total || 0),
          type: row.type,
          salesTax: Number(row.salesTax || 0),
          deliveryFee: Number(row.deliveryFee || 0),
          items: row.items,
          status: row.status,
          totalAmountReceived,
          balanceDue: Number(row.total || 0) - totalAmountReceived,
          paymentRecords: row.paymentRecords,
        };
      }),
      email: recipientEmail,
      bccList: warehouseEmailList,
    };

    axios
      .post(`${process.env.REACT_APP_API}/pdfs/send-statement`, payload)
      .then(() => setSendStatementStatus('success'))
      .catch(() => setSendStatementStatus('error'));
  };


  const riskyInvoiceIds = React.useMemo(() => {
    const riskySet = new Set();
    const resolvedSet = new Set();
    (rows || []).forEach(inv => {
      const hasRiskyItem = (inv?.items || []).some(item => {
        const unitCost = parseFloat(item?.unitCost) || 0;
        const unitPrice = parseFloat(item?.unitPrice) || 0;
        return unitCost > unitPrice;
      });
      if (hasRiskyItem) {
        const id = String(inv?._id || '');
        if (!id) return;
        if (inv?.flaggedResolved) resolvedSet.add(id);
        else riskySet.add(id);
      }
    });
    return { riskySet, resolvedSet };
  }, [rows]);

  const columns = [
    {
      field: 'invoiceNumber',
      headerName: 'Invoice #',
      editable: false,
      minWidth: 120,
      flex: 0.6,
    },
    {
      field: 'client',
      headerName: 'Client',
       type: 'singleSelect',
      valueOptions: clientArray,
      editable: false,
      minWidth: 125,
      flex: 1,
      valueGetter: (params) => {
        if (!params.value) {
          return params.value;
        }
        const valueFormatted = params.value.store;
        return valueFormatted;
      }, 
    },
    {
      field: 'clientPONumber',
      headerName: 'Client PO #',
      editable: false,
      minWidth: 140,
      flex: 0.9,
      valueGetter: (params) => params.value || '—',
    },
    { 
      field: 'total', 
      headerName: 'Amount', 
      editable: false,
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => {
        if (!params.value) {
          return params.value;
        }
        return displayFromDollars(params.value);
      },
    },
    { 
      flex: 1,
      minWidth: 150,
      field: 'receivedByDate', 
      headerName: 'Received Date',
      editable: false,
      type: 'date',
      valueGetter: (params) => {
        if (!params.value) {
          return params.value;
        }
        // const valueFormatted = moment(params.value).format('MM/DD/yyyy');
        // return valueFormatted;
        const valueFormatted = new Date(params.value);
        return valueFormatted;
      },
    },
    { 
      flex: 1,
      minWidth: 150,
      field: 'dueDate', 
      headerName: 'Due Date', 
      editable: false,
      type: 'date',
      valueGetter: (params) => {
        if (!params.value) {
          return params.value;
        }
        // const valueFormatted = moment(params.value).format('MM/DD/yyyy');
        // return valueFormatted;
        const valueFormatted = new Date(params.value);
        return valueFormatted;
      },
    },
    { field: 'status',
      type: 'singleSelect',
      valueOptions: statuses,
       headerName: 'Status',
       width: 165,
       renderCell: (params) => {
      const history = Array.isArray(params?.row?.sendHistory) ? params.row.sendHistory : [];
      const sentTypes = new Set(
        history
          .map((entry) => entry?.eventType)
          .filter(Boolean)
      );
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
          <button style={checkStatus(params.value)}>{params.value}</button>
          <div style={{ display: 'flex', gap: 6, lineHeight: 1 }}>
            {SEND_FLOW.map((step) => {
              const sent = sentTypes.has(step.eventType);
              return (
                <span
                  key={step.eventType}
                  title={step.label}
                  style={{
                    fontSize: 14,
                    fontWeight: 700,
                    color: sent ? '#15803d' : '#64748b',
                    width: 12,
                    textAlign: 'center',
                    userSelect: 'none',
                  }}
                >
                  {sent ? '✓' : '•'}
                </span>
              );
            })}
          </div>
        </div>
      );
    } },
    { field: 'actions', headerName: 'Actions', headerAlign: 'center', align: 'center', flex:1, minWidth: 200, renderCell: (params) => {
      return (
        <div style={{display: 'flex'}}>
          <Button
            style={{color: 'white', backgroundColor: 'rgb(25, 118, 210)', marginRight: 10}}
            onClick={() => editInvoice(params.row._id)}
            variant="contained"
          >
            Edit
          </Button>
          <Button
            style={{color: 'white', backgroundColor: 'red'}}
            onClick={(e) => {
              e.stopPropagation();
              setDeleteTargetId(params.row._id);
            }}
            variant="contained"
          >
            Delete
          </Button>
            
  
        </div>
        
      );
    } }
  ];

  const editInvoice = (id) => {
    history.push(`/edit/invoice/${id}`)
  }

  const openInvoice = (id) => {
    history.push(`/invoice/${id}`)
  }

  const handleCancelDelete = () => setDeleteTargetId(null);
  const handleConfirmDelete = async () => {
    if (deleteTargetId) {
      await dispatch(deleteInvoice(deleteTargetId, openSnackbar));
      setRefreshKey((value) => value + 1);
    }
    setDeleteTargetId(null);
  };

  const getClientLabel = React.useCallback((row = {}) => invoiceClientLabel(row) || 'No client', [invoiceClientLabel]);

  const formatDate = (value) => {
    const date = moment(value);
    return date.isValid() ? date.format('MMM D, YYYY') : 'No date';
  };

  const formatMoney = (value) => displayFromDollars(Number(value || 0));

  const getBalanceDue = (row = {}) => {
    const paid = Array.isArray(row.paymentRecords)
      ? row.paymentRecords.reduce((sum, record) => sum + Number(record?.amountPaid || 0), 0)
      : 0;
    return Number(row.total || 0) - paid;
  };

  const openMobileDetail = (invoice) => {
    setMobileDetailInvoice(invoice);
    if (mobileDetailOpen) return;
    window.requestAnimationFrame(() => setMobileDetailOpen(true));
  };

  const closeMobileDetail = () => {
    setMobileDetailOpen(false);
  };

  const handleMobileDetailTransitionEnd = (event) => {
    if (event.target !== event.currentTarget) return;
    if (!mobileDetailOpen) setMobileDetailInvoice(null);
  };

  const mobileColumns = React.useMemo(() => ([
    {
      field: 'invoiceNumber',
      headerName: 'Invoice',
      minWidth: 104,
      flex: 0.8,
      valueGetter: (params) => params.value || params?.row?.rowNumber || '—',
    },
    {
      field: 'client',
      headerName: 'Client',
      type: 'singleSelect',
      valueOptions: clientArray,
      minWidth: 124,
      flex: 1,
      valueGetter: (params) => getClientLabel(params.row),
    },
    {
      field: 'total',
      headerName: 'Amount',
      minWidth: 96,
      flex: 0.75,
      valueGetter: (params) => formatMoney(params.value),
    },
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 96,
      flex: 0.7,
      renderCell: (params) => {
        const sentTypes = new Set(
          (params?.row?.sendHistory || [])
            .map((entry) => entry?.eventType)
            .filter(Boolean)
        );
        return (
          <div className={styles.mobileGridStatusCell}>
            <button className={styles.mobileGridStatus} style={checkStatus(params.value)}>
              {params.value}
            </button>
            <div className={styles.mobileGridStatusFlow}>
              {SEND_FLOW.map((step) => {
                const sent = sentTypes.has(step.eventType);
                return (
                  <span
                    key={step.eventType}
                    title={step.label}
                    className={sent ? styles.mobileGridSent : styles.mobileGridNotSent}
                  >
                    {sent ? '✓' : '•'}
                  </span>
                );
              })}
            </div>
          </div>
        );
      },
    },
  ]), [clientArray, getClientLabel]);

  const hasActiveGridFilters = React.useMemo(() => (
    (gridState.filterModel?.items || []).some((item) => item?.value !== undefined && item?.value !== null && item?.value !== '')
  ), [gridState.filterModel]);

  if(!authData) {
    history.push('/login')
  }



  function checkStatus(status) {
    return status === "Partial" ? {border: 'solid 0px #1976d2', backgroundColor: '#baddff', padding: '8px 18px', borderRadius: '20px' }
        : status === "Paid" ? {border: 'solid 0px green', backgroundColor: '#a5ffcd', padding: '8px 18px', borderRadius: '20px' }
        : status === "Unpaid" ? {border: 'solid 0px red', backgroundColor: '#ffaa91', padding: '8px 18px', borderRadius: '20px' }
        : "red";
          
}

  if(isLoading) {
    return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px'}}>
        <Spinner />
    </div>
  }

  if(!isLoading && rows.length === 0 && rowCount === 0 && !hasActiveGridFilters) {
    return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px', margin: '80px'}}>
      <NoData />
    <p style={{padding: '40px', color: 'gray', textAlign: 'center'}}>No invoice yet. Click the plus icon to create invoice</p>
  
    </div>
  }
  
  return (
    <div className={styles.pageLayout}>
      <Dialog open={Boolean(deleteTargetId)} onClose={handleCancelDelete}>
        <DialogTitle>Delete Invoice</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this invoice? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Container style={{maxWidth: 1600}}>
        <div className={styles.buttons}>
        <h1 className={styles.pageTitle}>Invoices</h1>
        <div className={styles.actionButtonGrid}>
          <ProgressButton 
            className={styles.actionProgressButton}
            onClick={printInvoices} 
            state={downloadStatus}>
            {isMobile ? 'All' : 'Print All'}
          </ProgressButton>
          <ProgressButton 
            className={styles.actionProgressButton}
            onClick={printTdInvoices} 
            state={downloadTdStatus}>
            {isMobile ? 'Today' : 'Print Today'}
          </ProgressButton>
          <ProgressButton
            className={`${styles.actionProgressButton} ${styles.statementActionButton}`}
            onClick={downloadStatement}
            state={downloadStatementStatus}
            disabled={!selectedClientFilter}
          >
            {isMobile ? 'Statement' : 'Download Statement'}
          </ProgressButton>
          <ProgressButton
            className={`${styles.actionProgressButton} ${styles.statementActionButton}`}
            onClick={sendStatement}
            state={sendStatementStatus}
            disabled={!selectedClientFilter}
          >
            {isMobile ? 'Send' : 'Send Statement'}
          </ProgressButton>
        </div>
        </div>
        <p className={styles.statementHint}>To download statement select client</p>
        {isMobile ? (
          <div className={styles.mobileGridSample}>
            <div className={styles.mobileResultMeta}>
              <span>Tap a row for details</span>
            </div>

            <div className={styles.mobileDataGridWrap}>
              <DataGrid
                autoHeight
                rows={rows}
                getRowId={(row) => row._id}
                getRowHeight={() => 'auto'}
                columns={mobileColumns}
                loading={listLoading}
                rowCount={rowCount}
                paginationMode="server"
                sortingMode="server"
                filterMode="server"
                filterModel={gridState.filterModel}
                onFilterModelChange={(filterModel) => updateGridState((prev) => ({
                  ...prev,
                  filterModel,
                  paginationModel: { ...prev.paginationModel, page: 0 },
                }))}
                sortModel={gridState.sortModel}
                onSortModelChange={(sortModel) => updateGridState({ sortModel })}
                paginationModel={gridState.paginationModel}
                onPaginationModelChange={(paginationModel) => updateGridState({ paginationModel })}
                pageSizeOptions={[10, 20, 50]}
                components={{
                  Toolbar: GridToolbar,
                }}
                onRowClick={(params) => openMobileDetail(params.row)}
                sortingOrder={['desc', 'asc']}
                getRowClassName={(params) => {
                  const rowId = String(params.id || '');
                  const classNames = [];
                  if (rowId === String(todayBoundaryInvoiceId || '')) classNames.push(styles.todayBoundaryRow);
                  if (riskyInvoiceIds.resolvedSet.has(rowId)) classNames.push(styles.costWarningResolvedRow);
                  if (riskyInvoiceIds.riskySet.has(rowId)) classNames.push(styles.costWarningRow);
                  return classNames.join(' ');
                }}
                sx={{
                  border: '1px solid #dbe3ef',
                  borderRadius: '12px',
                  backgroundColor: '#fff',
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#f8fafc',
                    minHeight: '42px !important',
                  },
                  '& .MuiDataGrid-columnHeaderTitle': {
                    fontSize: '12px',
                    fontWeight: 800,
                  },
                  '& .MuiDataGrid-cell': {
                    py: '8px',
                    fontSize: '13px',
                    whiteSpace: 'normal',
                    lineHeight: 1.25,
                  },
                  '& .MuiDataGrid-row': {
                    cursor: 'pointer',
                  },
                  '& .MuiDataGrid-toolbarContainer': {
                    flexWrap: 'wrap',
                    gap: '4px',
                    p: '6px',
                  },
                  '& .MuiTablePagination-toolbar': {
                    px: '8px',
                  },
                }}
              />
            </div>

            {mobileDetailInvoice && (
              <aside
                className={`${styles.mobileDetailSidenav} ${mobileDetailOpen ? styles.mobileDetailSidenavOpen : ""}`}
                aria-label="Invoice details"
                onTransitionEnd={handleMobileDetailTransitionEnd}
              >
                <div className={styles.mobileDetailContent}>
                  <div className={styles.mobileDetailTopBar}>
                    <span>Invoice details</span>
                    <Button size="small" color="primary" onClick={closeMobileDetail}>
                      Close
                    </Button>
                  </div>
                  <div className={styles.mobileDetailHeader}>
                    <div>
                      <h2>{mobileDetailInvoice.invoiceNumber || `Invoice ${mobileDetailInvoice.rowNumber || ''}`}</h2>
                      <p>{getClientLabel(mobileDetailInvoice)}</p>
                    </div>
                    <div className={styles.mobileDetailAmount}>
                      <strong>{formatMoney(mobileDetailInvoice.total)}</strong>
                      <span>Bal {formatMoney(getBalanceDue(mobileDetailInvoice))}</span>
                    </div>
                  </div>

                  <div className={styles.mobileDetailGrid}>
                    <div>
                      <span>Received</span>
                      <strong>{formatDate(mobileDetailInvoice.receivedByDate)}</strong>
                    </div>
                    <div>
                      <span>Due</span>
                      <strong>{formatDate(mobileDetailInvoice.dueDate)}</strong>
                    </div>
                    <div>
                      <span>Status</span>
                      <strong>
                        <button className={styles.mobileGridStatus} style={checkStatus(mobileDetailInvoice.status)}>
                          {mobileDetailInvoice.status}
                        </button>
                      </strong>
                    </div>
                    <div>
                      <span>Client PO</span>
                      <strong>{mobileDetailInvoice.clientPONumber || '—'}</strong>
                    </div>
                  </div>

                  <div className={styles.mobileDetailSection}>
                    <h3>Send Status</h3>
                    <div className={styles.mobileSendFlow}>
                      {SEND_FLOW.map((step) => {
                        const sentTypes = new Set(
                          (mobileDetailInvoice.sendHistory || [])
                            .map((entry) => entry?.eventType)
                            .filter(Boolean)
                        );
                        const sent = sentTypes.has(step.eventType);
                        return (
                          <span key={step.eventType} className={sent ? styles.mobileSent : styles.mobileNotSent}>
                            {sent ? '✓' : '•'} {step.label}
                          </span>
                        );
                      })}
                    </div>
                  </div>

                  <div className={styles.mobileDetailSection}>
                    <h3>Items</h3>
                    {(mobileDetailInvoice.items || []).length === 0 ? (
                      <p className={styles.mobileMuted}>No items listed.</p>
                    ) : (
                      <div className={styles.mobileItemList}>
                        {(mobileDetailInvoice.items || []).map((item, index) => (
                          <div key={`${item?.modelNumber || item?.description || 'item'}-${index}`}>
                            <span>{item?.modelNumber || item?.description || 'Item'}</span>
                            <strong>{item?.quantity || item?.qty || 1} x {formatMoney(item?.unitPrice || item?.price || 0)}</strong>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className={styles.mobileDrawerActions}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => openInvoice(mobileDetailInvoice._id)}
                    >
                      View Invoice
                    </Button>
                    <Button
                      color="primary"
                      variant="outlined"
                      onClick={() => editInvoice(mobileDetailInvoice._id)}
                    >
                      Edit
                    </Button>
                    <Button
                      color="secondary"
                      variant="outlined"
                      onClick={() => {
                        setDeleteTargetId(mobileDetailInvoice._id);
                        closeMobileDetail();
                      }}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
              </aside>
            )}
          </div>
        ) : (
          <div className={styles.gridLayout}>
              <DataGrid
              sx={{
                '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '8px' },
                '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '12px' },
              }}
                autoHeight
                rows={rows}
                getRowId={(row) => row._id}
                getRowHeight={() => 'auto'}
                columns={columns}
                loading={listLoading}
                rowCount={rowCount}
                paginationMode="server"
                sortingMode="server"
                filterMode="server"
                filterModel={gridState.filterModel}
                onFilterModelChange={(filterModel) => {
                  updateGridState((prev) => ({
                    ...prev,
                    filterModel,
                    paginationModel: { ...prev.paginationModel, page: 0 },
                  }));
                }}
                sortModel={gridState.sortModel}
                onSortModelChange={(sortModel) => updateGridState({ sortModel })}
                paginationModel={gridState.paginationModel}
                onPaginationModelChange={(paginationModel) => updateGridState({ paginationModel })}
                pageSizeOptions={[20, 50, 100]}
                components={{
                  Toolbar: GridToolbar,
                }}
                onRowClick={(row) => openInvoice(row.id)}
                sortingOrder={['desc','asc']}
                getRowClassName={(params) => {
                  const rowId = String(params.id || '');
                  const classNames = [];
                  if (rowId === String(todayBoundaryInvoiceId || '')) classNames.push(styles.todayBoundaryRow);
                  if (riskyInvoiceIds.resolvedSet.has(rowId)) classNames.push(styles.costWarningResolvedRow);
                  if (riskyInvoiceIds.riskySet.has(rowId)) classNames.push(styles.costWarningRow);
                  return classNames.join(' ');
                }}
              />
          </div>
        )}
      </Container>
    </div>
  
  );
}

export default Invoices
